'use strict';

// source: https://codepen.io/bebjakub/pen/jWoYEO

function getUrlParameter(name) {
	//https://davidwalsh.name/query-string-javascript
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

(function ($) {
	$(window).on('load', function () {
		var $grid = $('.posts-learn-grid');
		var selector = '.post-learn-grid-item';
		var $items = $grid.find(selector);
		var url_filter = getUrlParameter('filter');

		if ($grid.length > 0) {
			// init Isotope
			var $container = $grid.isotope({
				itemSelector: selector,
				percentPosition: true,
				layoutMode: 'fitRows',
				fitRows: {
					gutter: '.gutter-sizer'
				}
			});

			if (url_filter) {
				$container.isotope({
					filter: '.filter-' + url_filter
				});
			}

			// bind filter button click
			$('#nav-secondary-tax-isotope-menu').on('click', 'span', function () {
				var filterValue = $(this).attr('data-filter');
				$container.isotope({
					filter: '.' + filterValue
				});
			});

			//****************************
			// Isotope Load more button
			//****************************
			var initShow = 999999999999999999999999999999999999999999999999999999999999999; //number of items loaded on init & onclick load more button
			var counter = initShow; //counter for load more button

			loadMore($container, initShow); //execute function onload

			//append load more button
			var buttonStyle = void 0;
			if ($items.length <= initShow) buttonStyle = 'display: none;';
			$container.after('<button id="load-more" class="btn btn-primary" style="' + buttonStyle + '"> Load More</button>');

			//when load more button clicked
			$('#load-more').click(function () {
				if ($('#filters').data('clicked')) {
					//when filter button clicked, set initial value for counter
					counter = initShow;
					$('#filters').data('clicked', false);
				}

				counter = counter + initShow;

				loadMore($container, counter);
			});

			//when filter button clicked
			$('#filters').click(function () {
				$(this).data('clicked', true);

				loadMore($container, initShow);
			});

			var query_param = window.location.href.split('?filter=');
			if (query_param[1]) setTimeout(function () {
				return $('#filters').find('[data-filter=\'.' + query_param[1] + '\']').click();
			}, 0);
		}

		function loadMore($container, toShow) {
			$container.find('.hidden').removeClass('hidden');
			var iso = $container.data('isotope');

			var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
				return item.element;
			});
			$(hiddenElems).addClass('hidden');
			$container.isotope('layout');

			//when no more to load, hide show more button
			if (hiddenElems.length == 0) {
				jQuery('#load-more').hide();
			} else {
				jQuery('#load-more').show();
			}
		}
	});
})(jQuery);